export const SORT = "SORT";



// WEBPACK FOOTER //
// ./src/constants.js